import { Button } from '@components/buttons'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box, Grid } from '@mui/material'
import { Actions } from '@state/actions'
import { useSelector } from '@state/store'
import { loginSchema } from '@utils/schemas'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import logo from '@assets/img/logos/ariane-fse.png'
import { PasswordInput, TextInput } from '@components/inputs'
import { LoginDto } from '@services/api'
import { getCaptcha, login } from '@state/thunks/authThunk'
import { CaptchaInput } from '@components/inputs/CaptchaInput'

export default function Login() {
  const dispatch = useDispatch()
  const { loading, captcha } = useSelector(({ auth, loading }) => ({
    captcha: auth.captcha,
    loading: loading[Actions.LOGIN],
  }))
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginDto>({
    defaultValues: {
      captcha: '',
      email: '',
      password: '',
    },
    resolver: yupResolver(loginSchema) as any,
  })

  const onSubmit = (values: LoginDto) => {
    dispatch(
      login({
        captcha: values.captcha,
        email: values.email.toLowerCase().trim(),
        password: values.password.trim(),
      }),
    )
  }

  const getAuthCaptcha = () => {
    dispatch(getCaptcha())
  }

  useEffect(() => {
    getAuthCaptcha()
  }, [])

  const Content = (
    <form className="space-y-3" onSubmit={handleSubmit(onSubmit)}>
      <TextInput
        variant="filled"
        type="email"
        name="email" // {...register('email')}
        label="Email"
        errors={errors}
        control={control}
        autoFocus
      />
      <PasswordInput
        variant="filled"
        name="password" // {...register('password')}
        label="Password"
        errors={errors}
        control={control}
      />
      <CaptchaInput
        captcha={captcha}
        getCaptcha={getAuthCaptcha}
        errors={errors}
        control={control}
      />
      <Button
        color="secondary"
        textColor="white"
        type="submit"
        text="submit"
        loading={loading}
        fullWidth
        format
      />
    </form>
  )
  const ActionsContent = (
    <Grid container justifyContent={'flex-end'} direction="row">
      <Button
        link="/auth/forgotten-password"
        text="forgot-password"
        textColor="white"
        format
      />
    </Grid>
  )
  return (
    <Box
      sx={{
        backgroundImage: 'linear-gradient(45deg, #303f9f, #7b1fa2)',
        borderRadius: 1,
        padding: 3,
        zIndex: 1,
      }}
    >
      <div className="bg-white mb-4">
        <img src={logo} alt="Ether HealthCare" className="w-full h-20" />
      </div>
      {Content}
      {ActionsContent}
    </Box>
  )
}
